var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddEvent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16C9.67155 16 9 16.6716 9 17.5C9 18.3284 9.67155 19 10.5 19C11.3284 19 12 18.3284 12 17.5C12 16.6716 11.3284 16 10.5 16Z",
    fill: "#10A37F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C6.44772 1 6 1.44772 6 2V3H5C3.34315 3 2 4.34315 2 6V20C2 21.6569 3.34315 23 5 23H14C14.5922 22.3005 14.6566 21.8758 14 21H5C4.44772 21 4 20.5523 4 20V11H20V13C20.7825 13.7002 21.2175 13.724 22 13V6C22 4.34315 20.6569 3 19 3H18V2C18 1.44772 17.5523 1 17 1C16.4477 1 16 1.44772 16 2V3H8V2C8 1.44772 7.55228 1 7 1ZM16 6V5H8V6C8 6.55228 7.55228 7 7 7C6.44772 7 6 6.55228 6 6V5H5C4.44772 5 4 5.44772 4 6V9H20V6C20 5.44772 19.5523 5 19 5H18V6C18 6.55228 17.5523 7 17 7C16.4477 7 16 6.55228 16 6Z",
    fill: "#10A37F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2799 14.8799C18.7166 14.8799 19.0705 15.2338 19.0705 15.6705V17.4493H20.8493C21.286 17.4493 21.6399 17.8032 21.6399 18.2399C21.6399 18.6765 21.286 19.0305 20.8493 19.0305H19.0705V20.8093C19.0705 21.2459 18.7166 21.5999 18.2799 21.5999C17.8433 21.5999 17.4893 21.2459 17.4893 20.8093V19.0305H15.7105C15.2739 19.0305 14.9199 18.6765 14.9199 18.2399C14.9199 17.8032 15.2739 17.4493 15.7105 17.4493H17.4893V15.6705C17.4893 15.2338 17.8433 14.8799 18.2799 14.8799Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddEvent);
export default __webpack_public_path__ + "static/media/icon-add-event.8f9c9cd0700770095b8841668d5112c2.svg";
export { ForwardRef as ReactComponent };